export const conditionalPopupCategories = {
  SubscribePopup: ['Productivity tips', 'Remote work tips', 'App tutorials'],
  SignupPopup: [
    'Automation inspiration',
    'Best apps',
    'Small business tips',
    'App comparisons',
    'App tips',
    'How we work at Zapier',
    'App of the day',
    'Zapier tutorials',
    'Customer stories',
  ],
};

export enum generalPopupsNameIds {
  SIGN_UP = 'signup_pre_intent',
  SUBSCRIBE = 'email_subscribe_confirm',
}
